import React, { useState } from "react";
import { formatNumber } from "../utils";

/**
 * NumberInput
 * Un input personnalisé qui formate le nombre saisi avec des séparateurs de milliers.
 * Props :
 *  - name: nom du champ (important pour les formulaires)
 *  - value: valeur numérique
 *  - onChange: fonction appelée avec la nouvelle valeur numérique
 *  - ...props: autres props passées à l'input
 */
const NumberInput = ({ name, value = "", onChange, ...props }) => {
  const [displayValue, setDisplayValue] = useState(formatNumber(value));

  // Gère la saisie utilisateur
  const handleInputChange = (e) => {
    if (!e || !e.target) return;

    const raw = e.target.value.replace(/\s/g, "").replace(",", ".");
    // Autorise uniquement les chiffres et un point
    const numericValue = parseFloat(raw);
    setDisplayValue(e.target.value);

    if (onChange) {
      // Si le composant parent attend juste la valeur numérique
      const finalValue = !isNaN(numericValue)
        ? numericValue
        : e.target.value === ""
        ? ""
        : value;

      onChange(finalValue);
    }
  };

  // Met à jour l'affichage si la prop value change
  React.useEffect(() => {
    // Assurer que la valeur n'est pas undefined
    setDisplayValue(formatNumber(value || ""));
  }, [value]);

  return (
    <input
      type="text"
      name={name}
      value={displayValue}
      onChange={handleInputChange}
      inputMode="decimal"
      {...props}
    />
  );
};

export default NumberInput;
